export const HeadersMobsVisits = [
    { text: "ID", value: "request_id", sortable: true, show: true },
    { text: "Tipo", value: "visit_type.id", sortable: false, show: true },
    { text: "Estado", value: "visit_status", groupable: false, sortable: false, show: true },
    { text: 'Categoría', value: "service_name", groupable: false, sortable: false, show: true },
    { text: 'Dirección', value: 'request.full_address', groupable: false, sortable: false, show: true },
    { text: 'Fecha', value: 'visit_date', groupable: false, sortable: false, show: true },
    { text: 'Hora Desde', value: 'arrival_time', groupable: false, sortable: true, show: true },
    { text: 'Hora Hasta', value: 'departure_time', groupable: false, sortable: true, show: true }
]